var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      !_vm.loading
        ? _c(
            "el-row",
            [
              _c(
                "el-col",
                { staticStyle: { border: "1px solid #ddd" } },
                [
                  _c(
                    "el-row",
                    {
                      staticStyle: {
                        background: "#f3f3f3",
                        height: "50px",
                        "line-height": "30px",
                        padding: "0 25px",
                        display: "flex",
                        "align-items": "center"
                      },
                      attrs: { span: 24 }
                    },
                    [
                      _c("el-col", { attrs: { span: 8 } }, [
                        _vm._v("数据列表：")
                      ]),
                      _vm._v(" "),
                      _c("el-col", {
                        staticStyle: { "text-align": "right" },
                        attrs: { span: 16 }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.resData
                    ? _c(
                        "div",
                        { staticStyle: { "margin-bottom": "0" } },
                        [
                          _c(
                            "el-table",
                            {
                              directives: [
                                {
                                  name: "loading",
                                  rawName: "v-loading",
                                  value: _vm.tableLoading,
                                  expression: "tableLoading"
                                }
                              ],
                              ref: "multipleTable",
                              staticStyle: { width: "100%" },
                              attrs: {
                                height: "800",
                                data: _vm.resData.list,
                                "tooltip-effect": "dark"
                              }
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  prop: "tally_task_id",
                                  label: "理货任务id",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "shipping_space",
                                  label: "仓位",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "goods_name",
                                  label: "商品名称",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "dbids",
                                  label: "打标id",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "",
                                  label: "货号/颜色/尺码",
                                  width: "120",
                                  align: "center"
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function(scope) {
                                        return [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(scope.row.goods_no) +
                                              "/" +
                                              _vm._s(scope.row.co_val) +
                                              "/" +
                                              _vm._s(scope.row.si_val) +
                                              "\n            "
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  false,
                                  369571237
                                )
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "sku",
                                  label: "sku编号",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "cat_name",
                                  label: "商品分类",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "supply_name",
                                  label: "商家",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "market_name",
                                  label: "市场",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "brand_name",
                                  label: "品牌",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "pgname",
                                  label: "代采组",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "admin_name",
                                  label: "代采员",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "tally_time",
                                  label: "理货时间",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "tally_problems",
                                  label: "理货问题",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              }),
                              _vm._v(" "),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "ex_dbids",
                                  label: "异常数据",
                                  "show-overflow-tooltip": "",
                                  align: "center"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.resData
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            "text-align": "right",
                            padding: "25px"
                          }
                        },
                        [
                          _c("el-pagination", {
                            attrs: {
                              "current-page": _vm.curPage,
                              background: "",
                              layout: "total, prev, pager, next, jumper ,sizes",
                              total: _vm.resData.count,
                              "page-size": _vm.form.pagesize,
                              "page-sizes": [50, 100, 200, 500]
                            },
                            on: {
                              "update:currentPage": function($event) {
                                _vm.curPage = $event
                              },
                              "update:current-page": function($event) {
                                _vm.curPage = $event
                              },
                              "current-change": _vm.handleCurrentChange,
                              "size-change": _vm.handleSizeChange
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bfd720a0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bfd720a0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/tallytask/TallyTaskDetail.vue
// module id = null
// module chunks = 